// extracted by mini-css-extract-plugin
export var content = "_nd-1";
export var fullScreen = "_nd-0";